import React, { useState } from 'react'

import { Icon } from '@mundi/design-system'
import { Link } from 'react-router-dom'
import { dispatchLocalStorage } from 'utils/localStorage'

import { ReactComponent as EEUU } from '../../assets/icons/EEUU.svg'
import logoUrl from '../../assets/icons/logo.svg'
import { ReactComponent as Mexico } from '../../assets/icons/Mexico.svg'
import ToolTip from './Tooltip'

const iconsLang = {
  en: <EEUU className="scale-75" />,
  es: <Mexico className="scale-75" />,
}

const Header: React.FC = () => {
  const locale = localStorage.getItem('locale')
  const initialMenuState =
    localStorage.getItem('mainMenuIsCollapsed') === 'true' || false

  const [nextLang, setNextLang] = useState('en')
  const [mainMenuIsCollapsed, setMainMenuIsCollapsed] =
    useState(initialMenuState)

  return (
    <div className="fixed z-50">
      <div className="flex items-center justify-between w-screen h-20 bg-white px-7">
        <div className="flex items-center">
          <div
            role="button"
            tabIndex={0}
            className="flex items-end justify-center inline w-8 rounded-full"
            onClick={() => {
              dispatchLocalStorage({
                key: 'mainMenuIsCollapsed',
                value: !mainMenuIsCollapsed,
                callback: ({ value }) => setMainMenuIsCollapsed(value),
              })
            }}
          >
            <Icon icon="burger-menu" iconSize={25} />
          </div>

          <Link className="ml-5" to="/">
            <img src={logoUrl} alt="Mundi-Logo" className="w-auto h-8" />
          </Link>
        </div>

        <div className="flex items-center">
          <button
            className="cursor-pointer"
            onClick={() => {
              dispatchLocalStorage({
                key: 'locale',
                value: locale === 'en' ? 'es' : 'en',
                callback: ({ value }) =>
                  setNextLang(value === 'en' ? 'es' : 'en'),
              })
            }}
          >
            {iconsLang[nextLang]}
          </button>
          <ToolTip />
        </div>
      </div>
    </div>
  )
}

export default Header
